<template>
    <div v-if="overlay" class="pnc-spinner-overlay">
        <div class="pnc-spinner-container">
            <div class="pnc-spinner-ring"></div>
            <p v-if="mensagem" class="pnc-spinner-msg">{{ mensagem }}</p>
        </div>
    </div>
    <div v-else class="d-flex justify-content-center align-items-center p-4">
        <div class="spinner-border text-primary" :style="{ width: tamanho, height: tamanho }" role="status">
            <span class="sr-only">Carregando...</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SpinnerPadrao',
    props: {
        overlay: { type: Boolean, default: false },
        mensagem: { type: String, default: null },
        tamanho: { type: String, default: '2rem' },
    },
};
</script>

<style scoped>
.pnc-spinner-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pnc-spinner-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
}

.pnc-spinner-ring {
    width: 56px;
    height: 56px;
    border: 4px solid rgba(59, 130, 246, 0.2);
    border-top-color: #3b82f6;
    border-right-color: #3b82f6;
    border-radius: 50%;
    animation: pnc-spin 0.8s linear infinite;
}

.pnc-spinner-msg {
    color: #e2e8f0;
    font-size: 0.9rem;
    margin: 0;
}

@keyframes pnc-spin {
    to { transform: rotate(360deg); }
}
</style>
